import { register } from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default register('trust-indicators', {
  onLoad() {
    this.thisSlider = document.querySelector(
      '#trust-indicators__slider--' + this.id
    );

    // Reduce slide count by one to align with the 0 positioned slide
    const trustSlidesCount = Number(this.container.dataset.slides - 1);
    this.trustIndicatorControllers = this.container.querySelector(
      '.controls-container--trust-indicators'
    );

    if (this.thisSlider) {
      var trustSlider = new Flickity(this.thisSlider, {
        freeScroll: false,
        autoplay: false,
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        setGallerySize: true,
        cellAlign: 'left',
        watchCSS: true,
        wrapAround: false,
      });

      const previousButtonTrust = this.trustIndicatorControllers.querySelector(
        '.btn--control__prev'
      );
      previousButtonTrust.addEventListener('click', function() {
        trustSlider.previous();
      });

      const nextButtonTrust = this.trustIndicatorControllers.querySelector(
        '.btn--control__next'
      );
      nextButtonTrust.addEventListener('click', function() {
        trustSlider.next();
      });

      trustSlider.on('change', function() {
        if (trustSlider.selectedIndex === 0) {
          previousButtonTrust.setAttribute('disabled', 'disabled');
          nextButtonTrust.removeAttribute('disabled');
        } else if (trustSlider.selectedIndex === trustSlidesCount) {
          nextButtonTrust.setAttribute('disabled', 'disabled');
          previousButtonTrust.removeAttribute('disabled');
        } else {
          nextButtonTrust.removeAttribute('disabled');
          previousButtonTrust.removeAttribute('disabled');
        }
      });
    }
  },
});
